/**
 * v0.9: Styles are now handled by a2ui-react components internally.
 * These functions are kept as no-ops for backward compatibility.
 */

export function injectStyles(): void {
  // v0.9: styles are inline in a2ui-react components (no external injection needed)
}

export function removeStyles(): void {
  // v0.9: no-op
}
